"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInquiryOrderCouponSearchModel = instanceOfInquiryOrderCouponSearchModel;
exports.InquiryOrderCouponSearchModelFromJSON = InquiryOrderCouponSearchModelFromJSON;
exports.InquiryOrderCouponSearchModelFromJSONTyped = InquiryOrderCouponSearchModelFromJSONTyped;
exports.InquiryOrderCouponSearchModelToJSON = InquiryOrderCouponSearchModelToJSON;
exports.InquiryOrderCouponSearchModelToJSONTyped = InquiryOrderCouponSearchModelToJSONTyped;
/**
 * Check if a given object implements the InquiryOrderCouponSearchModel interface.
 */
function instanceOfInquiryOrderCouponSearchModel(value) {
    return true;
}
function InquiryOrderCouponSearchModelFromJSON(json) {
    return InquiryOrderCouponSearchModelFromJSONTyped(json, false);
}
function InquiryOrderCouponSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'iofcFormNo': json['iofcFormNo'] == null ? undefined : json['iofcFormNo'],
    };
}
function InquiryOrderCouponSearchModelToJSON(json) {
    return InquiryOrderCouponSearchModelToJSONTyped(json, false);
}
function InquiryOrderCouponSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'iofcFormNo': value['iofcFormNo'],
    };
}
